import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { ReactComponent as SuccessIcon } from 'src/assets/svg/success-green-circle.svg';

import { styles } from './styles';

export const PaymentSuccessfulPage: FC = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();

    const transactionId = searchParams.get('id');

    return (
        <Box css={styles.container}>
            <Box css={styles.imageContainer} />

            <Box css={styles.wrapper}>
                <SuccessIcon />

                <Typography variant="h1">{t('payment_successful_header')}</Typography>

                <Box css={styles.content}>
                    {(t('payment_successful_body', { returnObjects: true }) as string[]).map(
                        (line) => (
                            <Typography
                                key={line}
                                variant="body3"
                                dangerouslySetInnerHTML={{ __html: line }}
                                sx={{ mb: 1 }}
                            />
                        )
                    )}
                    <Typography variant="body3" sx={{ fontWeight: 700 }}>
                        {transactionId}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};
